<template>
    <div>
        <router-view v-show="$route.meta.hasOwnProperty('detail') && $route.meta.detail"></router-view>
        <div class="wrap" v-show="!$route.meta.hasOwnProperty('detail') || !$route.meta.detail">
            <div class="container lnb">
                <div class="contents_wrap">
                    <div class="contents">
                        <div class="title">
                            {{ $route.meta.title }}

                            <el-button class="title_btn" type="primary" @click="$router.push('/item/create')">상품 등록</el-button>
                            <div class="clear"></div>
                        </div>
<!--                        <item-list-component :setRow="setRow"></item-list-component>-->
                        <elastic-list-component v-if="!isDetail" :elasticType="'item'"></elastic-list-component>
                    </div>
                    <page-footer></page-footer>
                </div>
            </div>
        </div>
<!--        <item-display-modify-modal :selectItems="selectRow"></item-display-modify-modal>-->
    </div>
</template>

<script>
    import ItemDisplayModifyModal from '@/components/modal/ItemDisplayModifyModal'
    // import ItemListComponent from "@/components/item/ItemListComponent"
    import EventBus from "@/mixins/event-bus.js"
    import ElasticListComponent from "@/components/elastic/ElasticListComponent";

    let params = {};
    export default {
        name: 'Item',
        components: {
            ItemDisplayModifyModal,
            // ItemListComponent
            ElasticListComponent
        },
        data() {
            return{
                selectRow: [],
                isDetail: false,
            }
        },
        created(){
            if(this.$route.meta.detail) {
                this.isDetail = true;
            }
        },
        mounted() {
        },
        beforeRouteLeave(to, from, next){
            if(to.path === "/auth" && this.$localStorage.get('token')){
                next(false);
            }else{
                return next();
            }
        },
        computed: {

        },
        methods: {
            setRow(rows) {
                this.selectRow = rows;
            },
        },
        watch: {
            '$route.path': {
                deep: true,
                handler: function (val, oldVal) {
                    if(this.isDetail && this.$route.meta.detail != true) {
                        this.isDetail = false;
                    }
                }
            },
        },
    }
</script>
